import { useWorkspace } from '@/contexts/WorkspaceContext'
import { useAppSelector } from '@/store/hooks'
import { selectListById } from '@/store/lists/listsSelectors'
import Avatar from '@/components/ui/Avatar/Avatar'
import ActivitySourceBadge from '@/components/app/ActivitySourceBadge/ActivitySourceBadge'
import { TextMidd } from '@/components/ui/Text'
import { useRelativeTime } from '@/hooks/useRelativeTime'
import type { ActivityEvent } from '@/store/activity/activitySlice'
import { getActivityActionText } from '@/store/activity/activityUtils'
import { getActivityActorDisplay } from '@/utils/activityActorDisplay'
import css from './TaskModalActivityEvent.module.css'

interface Props {
    event: ActivityEvent
}

const TaskModalActivityEvent = ({ event }: Props) => {
    const { getMember, statuses } = useWorkspace()
    const formatRelativeTime = useRelativeTime()
    const fromListName = useAppSelector(state =>
        event.meta.fromListId ? selectListById(state, event.meta.fromListId)?.name : undefined
    )
    const toListName = useAppSelector(state =>
        event.meta.toListId ? selectListById(state, event.meta.toListId)?.name : undefined
    )

    const { displayName, avatarColor, avatarImage } = getActivityActorDisplay(event, getMember)

    const actionText = getActivityActionText(event, {
        statuses,
        getMember,
        fromListName,
        toListName,
        taskContext: true,
    })

    return (
        <div className={css.event}>
            <div className={css.avatar}>
                <Avatar
                    title={displayName}
                    color={avatarColor}
                    avatar={avatarImage}
                />
            </div>
            <div className={css.content}>
                <div className={css.text}>
                    <TextMidd>
                        <span className={css.actor}>{displayName}</span>
                        <ActivitySourceBadge event={event} />
                        {' '}
                        <span className={css.action}>{actionText}</span>
                    </TextMidd>
                </div>
                {event.createdAt && (
                    <TextMidd className={css.time}>{formatRelativeTime(event.createdAt)}</TextMidd>
                )}
            </div>
        </div>
    )
}

export default TaskModalActivityEvent
